<template>
  <div class="pa-0">
    <div class="setting-item mb-4">
      <v-switch
        @change="handleOrderMealChange"
        v-model="settings.order_from_one_shift_to_another"
        :label="$t('order_meal_from_one_shift_to_another')"
        inset
        color="primary"
        hide-details
      />
    </div>

    <div v-show="!settings.order_from_one_shift_to_another">
      <v-divider class="my-4"></v-divider>

      <div class="setting-item mb-4 ml-4">
        <v-switch
          @change="handleCurrentShiftChange"
          v-model="settings.current_shift_meal"
          :label="$t('role') + ' ' + $t('current_shift_meal')"
          inset
          color="primary"
          hide-details
        />
      </div>

      <div v-show="!settings.current_shift_meal">
        <div class="setting-item mb-4 ml-4">
          <v-switch
            v-model="settings.order_from_one_shift_to_another_can"
            :label="$t('automatic_shift_recognition')"
            inset
            color="primary"
            hide-details
          />
        </div>

        <div v-show="settings.order_from_one_shift_to_another_can" class="ml-4 mt-4">
          <div class="mb-2">
            <v-icon small color="primary" class="mr-2">mdi-information</v-icon>
            <span class="text-subtitle-2">{{ $t("order_meal_from_desc") }}</span>
          </div>
          <div class="mb-4">
            <span class="text-subtitle-2 font-weight-bold primary--text">{{
              $t("delivery_shift")
            }}</span>
          </div>

          <div
            v-for="shift in activeShifts"
            :key="shift.key"
            class="shift-settings pa-3 mb-3 grey lighten-4 rounded"
          >
            <div class="shift-header mb-3">
              <v-chip x-small color="primary" outlined> {{ $t(shift.label) }}* </v-chip>
              <span
                v-if="company.delivery_from_hour && company.delivery_to_hour"
                class="ml-2 text-caption grey--text"
              >
                ({{ company.delivery_from_hour }}:{{ company.delivery_from_min }} -
                {{ company.delivery_to_hour }}:{{ company.delivery_to_min }})
              </span>
            </div>

            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                <autocomplete
                  :items="deliveryHours"
                  item-value="val"
                  item-text="text"
                  v-model="settings[shift.key].delivery_from_hour"
                  :label="$t('starting_from_h')"
                  color="white"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <autocomplete
                  :items="deliveryMinutes"
                  item-value="val"
                  v-model="settings[shift.key].delivery_from_min"
                  :label="$t('starting_from_min')"
                  color="white"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <autocomplete
                  :items="deliveryHours"
                  item-value="val"
                  item-text="text"
                  v-model="settings[shift.key].delivery_to_hour"
                  :label="$t('up_to_h')"
                  color="white"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <autocomplete
                  :items="deliveryMinutes"
                  item-value="val"
                  v-model="settings[shift.key].delivery_to_min"
                  :label="$t('up_to_min')"
                  color="white"
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShiftOrderingSettingsTab",
  props: {
    settings: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
    deliveryHours: {
      type: Array,
      required: true,
    },
    deliveryMinutes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    activeShifts() {
      const shifts = [
        { key: "shift_one", label: "shift_one", active: this.company.shift_one },
        { key: "shift_two", label: "shift_two", active: this.company.shift_two },
        { key: "shift_three", label: "shift_three", active: this.company.shift_three },
        { key: "shift_four", label: "shift_four", active: this.company.shift_four },
      ];
      return shifts.filter((s) => s.active);
    },
  },
  methods: {
    handleOrderMealChange() {
      this.$emit("order-meal-change");
    },
    handleCurrentShiftChange() {
      this.$emit("current-shift-change");
    },
  },
};
</script>

<style scoped>
.setting-item {
  min-height: 48px;
  display: flex;
  align-items: center;
}

.setting-label {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.section-title {
  display: flex;
  align-items: center;
}

.section-subtitle {
  margin-top: 8px;
}

.shift-settings {
  margin-bottom: 12px;
}

.shift-header {
  display: flex;
  align-items: center;
}
</style>
